<template>
  <v-avatar
    :size="size"
    class="os-avatar"
    :color="color"
  >
    <img :src="src" :alt="alt" />
  </v-avatar>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: 'avatar'
    },
    size: {
      type: [String, Number],
      default: 50
    },
    color: {
      type: String,
      default: 'transparent' // Puedes poner un color o dejarlo transparente.
    }
  }
})
export default class Avatar extends Vue {}
</script>

<style scoped>
.os-avatar {
  border: 2px solid rgba(0, 0, 0, 0.1); /* Borde suave */
  border-radius: 50%; /* Circular */
  overflow: hidden;
}
</style>
